<svg
  viewBox="0 0 24 24"
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  stroke="currentColor"
  stroke-linecap="round"
  stroke-linejoin="round"
  aria-hidden="true"
  focusable="false"
>
  @switch (name) {
    @case ('away') {
      <g stroke-width="1.9">
        <circle cx="12" cy="12" r="9" />
        <path d="M8 12h8" />
      </g>
    }
    @case ('check') {
      <path stroke-width="2.4" d="M5 13l4 4L19 7" />
    }
    @case ('chevron') {
      <path stroke-width="2" d="m9 6 6 6-6 6" />
    }
    @case ('close') {
      <path stroke-width="2.2" d="M6 6l12 12M18 6 6 18" />
    }
    @case ('external') {
      <path
        stroke-width="2"
        d="M14 4h6v6M20 4l-9 9M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5"
      />
    }
    @case ('merge') {
      <path
        stroke-width="1.9"
        d="M6 4v5a6 6 0 0 0 6 6h6M6 20v-3M15 12l3 3-3 3"
      />
    }
    @case ('plus') {
      <path stroke-width="2.2" d="M12 5v14M5 12h14" />
    }
    @case ('rows') {
      <g stroke-width="1.9">
        <rect x="3" y="4" width="18" height="5" rx="1.5" />
        <rect x="3" y="11" width="18" height="5" rx="1.5" />
        <rect x="3" y="18" width="18" height="2.5" rx="1.25" />
      </g>
    }
    @case ('search') {
      <g stroke-width="2">
        <circle cx="11" cy="11" r="7" />
        <path d="m20 20-3.2-3.2" />
      </g>
    }
    @case ('trash') {
      <path stroke-width="1.9" d="M4 7h16M9 7V5h6v2M6 7l1 13h10l1-13" />
    }
  }
</svg>
